export function ServicesQuery(filter: string) {
  return `{
    queryServicosContents(filter: "${filter}") {
      data {
        titulo {
          iv
        }
        subtitulo {
          iv
        }
        descricao {
          iv
        }
        botoes {
          iv {
            cor
            uRL
            pagina {
              data {
                slug {
                  iv
                }
              }
            }
            modal {
              id
            }
            titulo
          }
        }
        dicas {
          iv {
            descricao
          }
        }
        icones {
          iv {
            imagem {
              id
            }
            titulo
            uRL
            pagina {
              data {
                slug {
                  iv
                }
              }
            }
          }
        }
        imagem {
          iv {
            id
          }
        }
        corDestaque {
          iv
        }
        links {
          iv {
            title
            modal {
              id
            }
            page {
              data {
                slug {
                  iv
                }
              }
            }
          }
        }
        imagemPrimeiro {
          iv
        }
        espacoAbaixo {
          iv
        }
      }
    }
  }
  `;
}

export function FilterQuery(name: string) {
  return `
  {
    queryFiltrosContents(filter: "data/Nome/iv eq '${name}'") {
      data {
        nome {
          iv
        }
        titulo {
          iv
        }
        subtitulo {
          iv
        }
        linksHeader {
          iv {
            titulo
            uRL
            icone {
              id
            }
            pagina {
              data {
                slug {
                  iv
                }
              }
            }
          }
        }
        descricaoDestaque {
          iv
        }
        cards {
          iv {
            titulo
            descricao
            navegarPara {
              ... on Paginas {
                data {
                  slug {
                    iv
                  }
                }
              }
            }
          }
        }
        botoes {
          iv {
            titulo
            uRL
            cor
            pagina {
              data {
                slug {
                  iv
                }
              }
            }
          }
        }
      }
    }
  }
  `;
}

export function BenefitsQuery(nome: string) {
  return `
    {
      queryBeneficiosContents(filter: "data/Nome/iv eq '${nome}'") {
        data {
          titulo {
            iv
          }
          subtitulo {
            iv
          }
          links {
            iv {
              titulo
              uRL
              modal {
                id
              }
            }
          }
          itens {
            iv {
              titulo
              subtitulo
              colunas
              linhas
              modal {
                id
              }
              imagemFundo {
                id
              }
              icone {
                id
              }
              botaoDescricao
              pagina {
                data {
                  slug {
                    iv
                  }
                }
              }
            }
          }
        }
      }
    }
        `;
}

export function ModalQuery(modal: string) {
  return `
    {
      queryModalContents(filter: "id eq '${modal}'") {
        flatData {
          tituloAbas
          subtituloAbas
          titulo
          componentes {
            __typename
            ... on PaginasIncorporadas {
              flatData {
                titulo
                subtitulo
                urlIframe
              }
            }
            ... on Abas {
              id
              flatData {
                titulo
                descricao
                grupo
                corDeFundo
                categoria
                components {
                  flatData {
                    __typename
                    conteudo {
                      titulo
                      descricao
                    }
                    categoria
                  }
                }
                seccoes {
                  flatData {
                    titulo
                    subtitulo
                    cards {
                      titulo
                      descricao
                    }
                  }
                }
                cards {
                  titulo
                  descricao
                  extraInfo {
                    flatData {
                      titulo
                      categoria
                      descricao
                    }
                  }
                }
              }
            }
            ... on ModalCards {
              flatData {
                titulo
                subtitulo
                cards {
                  titulo
                  descricao
                }
              }
            }
            ... on ModalDestaque {
              flatData {
                nome
                cards {
                  icone {
                    id
                  }
                  descricao
                }
              }
            }
            ... on ModalPerfil {
              flatData {
                titulo
                tipo
                itens {
                  titulo
                  descricao
                  cor
                  imagem {
                    id
                  }
                  rodape
                }
              }
            }
            ... on ModalLinhaTempo {
              flatData {
                descricao
                eventos {
                  titulo
                  descricao
                  ano
                }
              }
            }
            ... on TabelasDinamicas {
              flatData {
                header
                textAfter
                textBefore
                data {
                  flatData {
                    name
                    content
                  }
                }
              }
            }
            ... on Beneficios {
              flatData {
                titulo
                subtitulo
                links {
                  titulo
                  uRL
                  modal {
                    id
                  }
                }
                itens {
                  titulo
                  subtitulo
                  colunas
                  linhas
                  modal {
                    id
                  }
                  imagemFundo {
                    id
                  }
                  icone {
                    id
                  }
                  botaoDescricao
                  pagina {
                    flatData {
                      slug
                    }
                  }
                }
              }
            }
          }
          botoes {
            cores
            titulo
            uRL
          }
          tipoConteudo
          texto
          imagem {
            id
          }
          conteudo {
            descricao
            titulo
            imagem {
              id
            }
            externalLinks {
              flatData {
                title
                url
              }
            }
            documentos {
              flatData {
                name
                documents {
                  title
                  file {
                    id
                  }
                }
              }
            }
            components {
              __typename
              ... on TabelasDinamicas {
                flatData {
                  header
                  textAfter
                  textBefore
                  data {
                    flatData {
                      name
                      content
                    }
                  }
                }
              }
              ... on Accordion {
                flatData {
                  name
                  questions {
                    title
                    description
                  }
                }
              }
            }
          }
          documentos {
            titulo
            pDF {
              id
            }
          }
        }
      }
    }`;
}

export function ProfilesQuery() {
  return `
    {
      queryHomePerfisContents(orderby: "data/Ordem/iv") {
        data {
          descricaoBotao {iv}
          butttonBackgroundColor {iv}
          buttonBorderColor {iv}
          buttonTextColor {iv}
          icone {
            iv {
              id
            }
          }
          linkBotaoPagina {
            iv {
              __typename
              ... on Paginas {
                data {
                  slug {
                    iv
                  }
                }
              }
              ... on Filtros {
                data {
                  nome {
                    iv
                  }
                }
              }
            }
          }
          linkPageMaisServicos {
            iv {
              ... on Paginas {
                data {
                  slug {
                    iv
                  }
                }
              }
            }
          }
          linkBotaoUrl {
            iv
          }
          abrirURL {
            iv
          }
          modal {
            iv {
              id
            }
          }
          servicos {
            iv {
              titulo
              url
              modal {
                id
                data{
                  tipoConteudo {
                    iv
                  }
                }
              }
            }
          }
          titulo {iv}
        }
      }
    }
        `;
}

export function InsuranceQuery() {
  return `
        {
            queryBeneficiosContents(filter:"data/Nome/iv eq 'tipos-seguros'") {
              data {
                itens {
                  iv {
                    pagina {
                      data {
                        slug {
                          iv
                        }
                      }
                    }
                    titulo
                    subtitulo
                    imagemFundo {
                      id
                    }
                  }
                }
              }
            }
          }`;
}

export function PagesSlugQuery(id: string) {
  return `
    {
      queryPaginasContents(filter: "id eq '${id}'") {
        flatData {
          slug
        }
      }
    }`;
}

export function NewsSlugQuery(id: string) {
  return `
    {
      queryNoticiasContents(filter: "id eq '${id}'") {
        flatData {
          slug
        }
      }
    }`;
}

export function FindNewsByIdQuery(id: string) {
  return `
    {
      queryNoticiasContents(filter: "id eq '${id}'") {
        flatData {
          slug
          titulo
          subtitulo
          categoria
          tags
          data
          conteudo
          imagemDestaque {url}
          documents{pdf{url} title}
        }
      }
    }`;
}

export function PublishingSlugQuery(id: string) {
  return `
    {
      queryPublicacoesContents(filter: "id eq '${id}'") {
        flatData {
          slug
        }
      }
    }`;
}

export function PagesQuery(slug: string) {
  return `
    {
      queryPaginasContents(filter: "data/slug/iv eq '${slug}'") {
        data {
          nome {
            iv
          }
          slug {
            iv
          }
          componentes {
            iv {
              __typename
              ... on NewBanners {
                data {
                  title {
                    iv
                  }
                  subtitle {
                    iv
                  }
                  description {
                    iv
                  }
                  name {
                    iv
                  }
                  buttons {
                    iv {
                      title
                      butttonBackgroundColor
                      buttonBorderColor
                      buttonTextColor
                      modal {
                        id
                      }
                      url
                      page {
                        data {slug {iv}}
                      }
                    }
                  }
                  menu {
                    titulo
                    uRL
                    modal {
                      id
                    }
                    pagina {
                      flatData {
                        slug
                      }
                    }
                  }
                  background {
                    iv {
                      url
                    }
                  }
                }
              }
              ... on Certificacoes {
                data {
                  title { iv }
                  subtitle { iv }
                  img { iv { url } }
                }
              }
              ... on Contadores {
                data {
                  titulo {
                    iv
                  }
                  subtitulo {
                    iv
                  }
                  imagem {
                    iv {
                      id
                    }
                  }
                  contadores {
                    iv {
                      descricao
                      imagem {
                        id
                      }
                      valor
                      scale
                    }
                  }
                  botoes {
                    iv {
                      titulo
                      cores
                      uRL
                      modal {
                        id
                      }
                    }
                  }
                }
              }
              ... on PaginasIncorporadas {
                flatData {
                  titulo
                  subtitulo
                  urlIframe
                }
              }
              ... on Vantagens {
                data {
                  titulo {
                    iv
                  }
                  subtitulo {
                    iv
                  }
                  botoes {
                    iv {
                      titulo
                      cor
                      target {
                        ... on Servicos {
                          id
                        }
                      }
                    }
                  }
                  itens {
                    iv {
                      titulo
                      subtitulo
                      descricao
                      linkExterno
                      imagem {
                        id
                      }
                      modal {
                        ... on Modal {
                          id
                        }
                      }
                    }
                  }
                }
              }
              ... on Banners {
                flatData {
                  profiles
                  titulo
                  redeCredenciada
                  hasMargin
                  descricao
                  imagem {
                    id
                  }
                  botoes {
                    titulo
                    cor
                    uRL
                    page {
                      data {
                        slug { iv }
                      }
                    }
                    target {
                      ... on Formulario {
                        id
                      }
                    }
                    modal {
                      id
                    }
                  }
                  links {
                    titulo
                    uRL
                    pagina {
                      flatData {
                        slug
                      }
                    }
                    modal {
                      id
                    }
                    imagem {
                      id
                    }
                  }
                  menu {
                    titulo
                    uRL
                    modal {
                      id
                    }
                    pagina {
                      flatData {
                        slug
                      }
                    }
                  }
                }
              }
              ... on Beneficios {
                data {
                  titulo {
                    iv
                  }
                  subtitulo {
                    iv
                  }
                  links {
                    iv {
                      titulo
                      uRL
                      modal {
                        id
                      }
                    }
                  }
                  itens {
                    iv {
                      titulo
                      subtitulo
                      colunas
                      linhas
                      modal {
                        id
                      }
                      imagemFundo {
                        id
                      }
                      icone {
                        id
                      }
                      botaoDescricao
                      externalLink
                      pdf {
                        id
                      }
                      pagina {
                          data {
                            slug {
                              iv
                            }
                          }
                        }
                      }
                  }
                }
              }
              ... on Secao {
                data {
                  titulo {
                    iv
                  }
                  subtitulo {
                    iv
                  }
                  links {
                    iv {
                      descricaoLink
                      link
                      linkExterno
                      titulo
                      documento {
                        id
                      }
                      imagem {
                        id
                      }
                      modal {
                        id
                      }
                    }
                  }
                  rodape {
                    iv
                  }
                }
              }
              ... on Servicos {
                id
                data {
                  titulo {
                    iv
                  }
                  subtitulo {
                    iv
                  }
                  descricao {
                    iv
                  }
                  botoes {
                    iv {
                      cor
                      uRL
                      pagina {
                        data {
                          slug {
                            iv
                          }
                        }
                      }
                      modal {
                        id
                      }
                      titulo
                    }
                  }
                  dicas {
                    iv {
                      descricao
                    }
                  }
                  icones {
                    iv {
                      imagem {
                        id
                      }
                      titulo
                      uRL
                      pagina {
                        data {
                          slug {
                            iv
                          }
                        }
                      }
                      modal {
                        id
                      }
                    }
                  }
                  imagem {
                    iv {
                      id
                    }
                  }
                  corDestaque {
                    iv
                  }
                  links {
                    iv {
                      title
                      modal {
                        id
                      }
                      page {
                        data {
                          slug {
                            iv
                          }
                        }
                      }
                    }
                  }
                  imagemPrimeiro {
                    iv
                  }
                  espacoAbaixo {
                    iv
                  }
                }
              }
              ... on Graficos {
                data {
                  titulo {
                    iv
                  }
                  subtitulo {
                    iv
                  }
                  tipo {
                    iv
                  }
                  eixo {
                    iv {
                      valor
                      rotulo
                      cor
                    }
                  }
                  categoria {
                    iv
                  }
                  descricao {
                    iv
                  }
                  rodape {
                    iv
                  }
                }
              }

              ... on DestaquePlanosSaude {
                data {
                  titulo {
                    iv
                  }
                  subtitle {
                    iv
                  }
                  nome {
                    iv
                  }
                  cards {
                    iv {
                      titulo
                      subtitulo
                      modal {
                        id
                      }
                      imagem {
                        id
                      }
                    }
                  }
                }
              }
              ... on DestaqueNavegacao {
                flatData {
                  nome
                  navegarPara
                  imagem {
                    id
                  }
                  descricao
                  filter
                  botoes {
                    uRL
                    titulo
                    cor
                    modal {
                      id
                    }
                  }
                }
              }
              ... on NoticiasCarrossel {
                flatData {
                  title
                  max
                }
              }
              ... on Taxas {
                data {
                  title {
                    iv
                  }
                  description {
                    iv
                  }
                  links {
                    iv {
                      description
                      url
                      icon {
                        id
                      }
                    }
                  }
                  icon {
                    iv {
                      id
                    }
                  }
                }
              }
              ... on Social {
                data {
                  nome {
                    iv
                  }
                  titulo {
                    iv
                  }
                  cards {
                    iv {
                      titulo
                      descricao
                      imagem {
                        id
                      }
                    }
                  }
                }
              }
              ... on Faq {
                flatData {
                  categoria
                  title
                  conteudo {
                    titulo
                    descricao
                    documentos {
                      flatData {
                        name
                        documents {
                          title
                          file {
                            id
                          }
                        }
                      }
                    }
                    components {
                      __typename
                      ... on Accordion {
                        flatData {
                          name
                          questions {
                            title
                            description
                          }
                        }
                      }
                      ... on TabelasDinamicas {
                        flatData {
                          header
                          textAfter
                          textBefore
                          data {
                            flatData {
                              name
                              content
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              ... on Formulario {
                id
                data {
                  nome {
                    iv
                  }
                  titulo {
                    iv
                  }
                  email {
                    iv
                  }
                  descricaoBotao {
                    iv
                  }
                  assuntoMensagem {
                    iv
                  }
                  corpoMensagem {
                    iv
                  }
                  corDeFundo {
                    iv
                  }
                }
              }
              ... on ServicosGrupo {
                data {
                  nome {
                    iv
                  }
                  title {
                    iv
                  }
                  subtitle {
                    iv
                  }
                  listaServicos {
                    iv {
                      data {
                        nome {
                          iv
                        }
                        titulo {
                          iv
                        }
                        subtitulo {
                          iv
                        }
                        imagem {
                          iv {
                            id
                          }
                        }
                        icones {
                          iv {
                            titulo
                            uRL
                            modal {
                              id
                            }
                            imagem {
                              id
                            }
                          }
                        }
                        dicas {
                          iv {
                            descricao
                          }
                        }
                        descricao {
                          iv
                        }
                        corDestaque {
                          iv
                        }
                        botoes {
                          iv {
                            titulo
                            target {
                              ... on Formulario {
                                id
                              }
                            }
                            modal {
                              id
                            }
                            uRL
                            cor
                          }
                        }
                      }
                    }
                  }
                }
              }
              ... on Informativo {
                flatData {
                  nome
                  textoDestaque
                  informacaoPrincipal
                  descricao
                  botoes {
                    titulo
                    uRL
                    cor
                    modal {
                      id
                    }
                  }
                }
              }
              ... on CardIconeTituloLink {
                flatData {
                  nome
                  textoDestaque
                  icone {
                    url
                  }
                  uRL
                  pagina {
                    data {
                      slug {
                        iv
                      }
                    }
                  }
                  documento {
                    url
                  }
                  mostraLink
                }
              }
              ... on IconeTitulo {
                flatData {
                  nome
                  icone {
                    url
                  }
                  titulo
                }
              }
              ... on DescricaoCorFundo {
                flatData {
                  nome
                  descricao
                  corTexto
                  corFundo
                  centerTxt
                  hasMarginBottom
                }
              }
              ... on ImagemTituloDescricao {
                flatData {
                  nome
                  imagem {
                    url
                  }
                  titulo
                  descricao
                }
              }
              ... on Imagem{
                flatData {
                  nome
                  imagem {
                    url
                  }
                }
              }
              ... on LinkInternoVoltar {
                flatData {
                  nome
                  titulo
                  pagina {
                    data {
                      slug {
                        iv
                      }
                    }
                  }
                }
              }
              ... on TituloSubtituloCorFundo {
                flatData {
                  nome
                  titulo
                  subtitulo
                  corFundo
                }
              }
              ... on UnidadesClinica {
                flatData {
                  nome
                  titulo
                  clinicas {
                    nomeClinica
                    endereco
                    horarios
                  }
                }
              }
              ... on BannerTextoGrande{
                flatData {
                  nome
                  tiulo
                  subtitulo
                  imagem {
                    url
                  }
                }
              }
            }
          }
        }
      }
      }
    `;
}

export function NavActionsQuery() {
  return `
  {
    queryNavActionsContents {
      data {
        titulo {
          iv
        }
        botao {
          iv
        }
        pages {
          iv {
            title
            externalLink
            page {
              data {
                slug {iv}
              }
            }
          }
        }
      }
    }
  }
  `;
}

export function MenuHamburgerQuery() {
  return `
  {
    queryMenuHamburgerContents {
      data {
        title {
          iv
        }
        icon {
          iv {
            id
          }
        }
        firstSection {
          iv {
            description
            link
            modal {
              id
            }
            page {
              data {
                slug {
                  iv
                }
              }
            }
          }
        }
        subtitle {
          iv
        }
        secondSection {
          iv {
            description
            page {
              data {
                slug {
                  iv
                }
              }
            }
          }
        }
        position {
          iv
        }
      }
    }
  }
  `;
}

export function ConfigNewsQuery() {
  return `
  {
    queryConfiguracaoNoticiaContents {
      data{
        banner{iv{id}}
        destaqueGrande{iv{id}}
        destaquePequeno1{iv{id}}
        destaquePequeno2{iv{id}}
      }
    }
  }
  `;
}

export function HighlightNewsQuery(top: number, order: string) {
  return `{
    queryNoticiasContents(top: ${top}, orderby: "${order}") {
      id
      data{
        titulo{iv}
        subtitulo{iv}
        imagemDestaque{iv{id}}
        data{iv}
        slug{iv}
        categoria{iv}
      }
    }
  }`;
}

export function NewHighlightQuery(slug: string) {
  return `{
    queryNoticiasContents(filter: "data/slug/iv eq '${slug}'"){
      id
      data{
        titulo{iv}
        subtitulo{iv }
        tags{iv }
        imagemDestaque{iv{id}}
        data{iv}
        slug{iv}
        conteudo{iv}
        categoria{iv}
        documents {
          iv {
            title
            pdf {
              url
            }
          }
        }
      }
    }
  }`;
}

export function HighlightPublishingQuery() {
  return `{
    queryPublicacoesContents(top: 1000) {
      id
      data {
        titulo { iv }
        subtitulo { iv }
        category { iv }
        subcategory { iv }
        imagemDestaque { iv { url } }
        slug{iv}
        data { iv }
        conteudo{iv}
        documents {
          iv {
            title
            pdf {
              url
            }
          }
        }
        conteudo { iv }
      }
    }
  }
  `;
}

export function PublishingHighlightQuery(slug: string) {
  return `{
    queryPublicacoesContents(filter: "data/slug/iv eq '${slug}'"){
      id
      data {
        titulo { iv }
        subtitulo { iv }
        category { iv }
        subcategory { iv }
        imagemDestaque { iv {   url } }
        conteudo{iv}
        slug{iv}
        data { iv }
        documents {
          iv {
            title
            pdf {
              url
            }
          }
        }
        video {
          iv
          {
            ... on PaginasIncorporadas {
              flatData {
                titulo
                subtitulo
                urlIframe
              }
            }
          }
        }
      }
    }
  }
  `;
}

export function FooterLinksQuery() {
  return `{
    queryRodapeLinksContents {
      data {
        titulo{iv}
        ordem{iv}
        links{
          iv	{
            titulo
            page {
              ... on Paginas{
                data{
                  slug { iv }
                }
              }
            }
            link
            modal {
              ... on Abas {id}
              ... on Modal {id}
            }
          }
        }
        estiloMarcador{iv}
        buttons { iv { title exclusiveArea page { ... on Paginas { data { slug { iv } } } ... on PaginasIncorporadas { flatData { urlIframe } } } } }
        descricao{iv}
      }
    }
  }
  `;
}

export function searchPageByTags(term: string) {
  return `
  {
    queryPaginasContents (filter: "contains(data/Tags/iv, '${term}')") {
      data {
        nome {iv}
        slug {iv}
      }
    }
  }
  `;
}

export function searchNewsQuery(term: string) {
  return getQuerySearch('Noticias', term);
}

export function searchPublicationsQuery(term: string) {
  return getQuerySearch('Publicacoes', term);
}

function getQuerySearch(type: string, term: string) {
  return `{
    query${type}Contents  (filter: "contains(data/Conteudo/iv, '${term}') or contains(data/Titulo/iv, '${term}') or contains(data/Subtitulo/iv, '${term}')" orderby: "data/Data/iv desc"){
      id
      data {
        titulo { iv }
        subtitulo { iv }
        slug { iv }
      }
    }
  }`;
}

export function HealthPlansQuery() {
  return `{
    queryFamiliaSaudeContents {
      id
      data {
        titulo {
          iv
        }
        icone {
          iv {
            id
          }
        }
        empresas {
          iv {
            data {
              titulo {
                iv
              }
              planos {
                iv {
                  plano {
                    data {
                      titulo {
                        iv
                      }
                    }
                  }
                  pagina {
                    data {
                      slug {
                        iv
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }`;
}

export function HelpdeskQuery() {
  return `{
    queryAtendimentoContents {
      data {
        titulo {
          iv
        }
        tituloMini {
          iv
        }
        descricao {
          iv
        }
        botoes {
          iv {
            titulo
            uRL
          }
        }
      }
    }
  }`;
}

export function publishingAboutQuery(type: string) {
  return `{
    queryDetalhesPublicacoesContents(filter: "data/category/iv eq '${type}'"){
      data {
        category {
          iv
        }
        titulo {
          iv
        }
        subtitulo {
          iv
        }
        imagemDestaque{
          iv {
            url
          }
        }
        data {
          iv
        }
        modal {
          iv {
            id
          }
        }
      }
    }
  }`;
}

export function SurveyQuery(slug: string) {
  return `{
    queryQuestionarioContents(filter: "data/Slug/iv eq '${slug}'") {
      flatData {
        name
        slug
        questions {
          question
          slug
          icon {
            id
          }
          type
        }
        minMinutes
        minPages
      }
    }
  }`;
}

export function FooterQuery() {
  return `{
    queryRodapeContents {
      flatData {
        selos {
          titulo
          grande {
            id
          }
          mini {
            id
          }
          url
        }
        links {
          titulo
        }
        flutuante {
          __typename
          ... on Atendimento {
            flatData {
              titulo
              tituloMini
              descricao
              botoes {
                titulo
                uRL
              }
            }
          }
          ... on Questionario {
            flatData {
              name
              slug
              minMinutes
              minPages
              questions {
                question
                slug
                type
                icon {
                  id
                }
              }
            }
          }
        }
      }
    }
  }`;
}

export function ConfigQuery() {
  return `{
    queryConfiguracaoSiteContents {
      flatData {
        mainPage {
          flatData {
            slug
          }
        }
      }
    }
  }`;
}
